import { render, staticRenderFns } from "./FabricAdditionIndex.vue?vue&type=template&id=201c52ae&scoped=true&"
import script from "./FabricAdditionIndex.vue?vue&type=script&lang=js&"
export * from "./FabricAdditionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c52ae",
  null
  
)

export default component.exports